import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../../../login/data-access/auth.service';
import {Subscription, take} from "rxjs";
import {
  faBookOpen, faChevronDown,
  faFileCircleQuestion,
  faFileContract,
  faGear,
  faGlasses, faGraduationCap,
  faThLarge,
  faUsers
} from "@fortawesome/free-solid-svg-icons";
import {Dashboard, DashboardService} from "../../../shared/utils/dashboard-service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MenuItem} from "../../../shared/ui/dropdown-menu/dropdown-menu.component";

@Component({
    selector: 'app-dashboard-wrapper',
    templateUrl: './dashboard-wrapper.component.html',
    styleUrls: ['dashboard-wrapper.component.css'],
    standalone: false
})
export class DashboardWrapperComponent implements OnInit, OnDestroy {
  @Input() firstName: string = '';
  @Input() lastName: string = '';
  given_name: string = ''
  profile_pic: number | null = null
  selectedMenuClass = `border-radius: 8px; width: 100%; padding: 0.25rem 0.5rem; background: ${localStorage.getItem('primaryColor')}; color: white; margin-bottom: 0.25rem;`
  notSelectedMenuClass = `border-radius: 8px; width: 100%; padding: 0.25rem 0.5rem; margin-bottom: 0.25rem; background: #F6F7F8;`
  mobileSelectedMenuClass = `border-radius: 8px; width: 100%; padding: 0.25rem 0.5rem; background: ${localStorage.getItem('primaryColor')}; color: white; margin-bottom: 0.25rem; display: flex; align-items: center;`
  mobileNotSelectedClass = `border-radius: 8px; width: 100%; padding: 0.25rem 0.5rem; margin-bottom: 0.25rem; background: transparent; display: flex; align-items: center;`
  dashboardSwitchMenuItems: MenuItem[] = []

  // TODO check list privileges
  sideNavButtons = [
    {
      name: 'Dashboard',
      icon: faThLarge,
      clickAction: (i: number) => {
        this.sideNavButtons.forEach((button) => button.isSelected = false )
        this.sideNavButtons[i].isSelected = true
        this.sidenav.opened = false;
        this.dashboardClick()
      },
      style: () => {
        if(window.location.pathname === '/dashboard')
          return this.selectedMenuClass
        else
          return this.notSelectedMenuClass
      },
      mobileStyle: () => {
        if(window.location.pathname === '/dashboard')
          return this.mobileSelectedMenuClass
        else
          return this.mobileNotSelectedClass
      },
      isSelected: window.location.pathname === '/dashboard'
    },
    {
      name: 'Exams',
      icon: faBookOpen,
      clickAction: (i: number) => {
        this.sideNavButtons.forEach((button) => button.isSelected = false )
        this.sideNavButtons[i].isSelected = true
        this.sidenav.opened = false;
        this.examListAdminClick()
      },
      style: () => {
        if(window.location.pathname.includes('exam'))
          return this.selectedMenuClass
        else
          return this.notSelectedMenuClass
      },
      mobileStyle: () => {
        if(window.location.pathname.includes('exam'))
          return this.mobileSelectedMenuClass
        else
          return this.mobileNotSelectedClass
      },
      isSelected: window.location.pathname.includes('exam')
    }
  ]

  classroomStudentSideNavButtons = [{
    name: 'Dashboard',
    icon: faThLarge,
    clickAction: (i: number) => {
      this.classroomStudentSideNavButtons.forEach((button) => button.isSelected = false )
      this.classroomStudentSideNavButtons[i].isSelected = true
      this.sidenav.opened = false;
      this.dashboardClick()
    },
    style: () => {
      if(window.location.pathname === '/dashboard')
        return this.selectedMenuClass
      else
        return this.notSelectedMenuClass
    },
    mobileStyle: () => {
      if(window.location.pathname === '/dashboard')
        return this.mobileSelectedMenuClass
      else
        return this.mobileNotSelectedClass
    },
    isSelected: window.location.pathname === '/dashboard'
  }, {
    name: 'Assessments',
    icon: faFileContract,
    clickAction: (i: number) => {
      this.classroomStudentSideNavButtons.forEach((button) => button.isSelected = false )
      this.classroomStudentSideNavButtons[i].isSelected = true
      this.sidenav.opened = false;
      this.router.navigate(['dashboard/assessments'])
    },
    style: () => {
      if(window.location.pathname.includes('assessments'))
        return this.selectedMenuClass
      else
        return this.notSelectedMenuClass
    },
    mobileStyle: () => {
      if(window.location.pathname.includes('assessments'))
        return this.mobileSelectedMenuClass
      else
        return this.mobileNotSelectedClass
    },
    isSelected: window.location.pathname.includes('assessments')
    // TODO finish making the sidenav for Assessments
  }, {
    name: 'Gradebook',
    icon: faBookOpen,
    clickAction: (i: number) => {
      this.router.navigate(['dashboard/gradebook'])
    },
    style: () => {
      if(window.location.pathname.includes('gradebook'))
        return this.selectedMenuClass
      else
        return this.notSelectedMenuClass
    },
    mobileStyle: () => {
      if(window.location.pathname.includes('gradebook'))
        return this.mobileSelectedMenuClass
      else
        return this.mobileNotSelectedClass
    },
    isSelected: window.location.pathname.includes('gradebook')
    // TODO finish making the sidenav for gradebook
  }]

  constructor(
    protected router: Router,
    private authService: AuthService,
    private dashboardService: DashboardService,
    private _snackBar: MatSnackBar
  ) {}

  @ViewChild('sidenav') sidenav: any;
  isOpened = false;

  userSub: Subscription = this.authService.user$.subscribe((user) => {
    if (user) {
      this.firstName = user.given_name;
      this.lastName = user.family_name;
      this.given_name = user.given_name
      this.profile_pic = user.profile_pic
    }
  });

  examStudentDashboard = false
  examAdminDashboard = false
  examStudentClassroomDashboard = false
  permissionIsLoading = true
  permissionLoadingValue = 0
  showSwitchButton = false
  showContentExplorer = false
  listOfProfilePics = this.authService.listOfProfileImages

  // TODO use userAuthPermissionSub
  userPermissionSub: Subscription = this.authService.userDashboard$.pipe(take(1)).subscribe((user) => {
    if(user.success) {
      this.permissionLoadingValue = 25
      if(user && user.result.length > 0) {
        this.permissionLoadingValue = 50
        for(let permission of user.result) {
          if(permission.ui != null) {
            if(permission.ui === 'ExamStudentDash') {
              this.examStudentDashboard = true
            } else if(permission.ui === 'ExamAdminDash') {
              this.examAdminDashboard = true
            }
            if(permission.ui === 'ClassroomStudentDash') {
              this.examStudentClassroomDashboard = true
            }
            if(permission.ui === 'ContentExplorer')
              this.showContentExplorer = true
          }
        }
        if(user.result.some(el => el.ui === 'UserManage' || el.ui === 'RoleCreate' || el.ui === 'UserRoleManage')) {
          this.sideNavButtons.splice(2, 0,{
            name: 'Users',
            icon: faUsers,
            clickAction: (i: number) => {
              this.sideNavButtons.forEach((button) => button.isSelected = false )
              this.sideNavButtons[i].isSelected = true
              this.sidenav.opened = false;
              this.userManagement()
            },
            style: () => {
              if(window.location.pathname.includes('UserManagement'))
                return this.selectedMenuClass
              else
                return this.notSelectedMenuClass
            },
            mobileStyle: () => {
              if(window.location.pathname.includes('UserManagement'))
                return this.mobileSelectedMenuClass
              else
                return this.mobileNotSelectedClass
            },
            isSelected: window.location.pathname.includes('UserManagement')
          })
        }
        if(user.result.some(el => el.ui === 'ContentExplorer')) {
          this.sideNavButtons.splice(3, 0, {
            name: 'Content Viewer',
            icon: faGlasses,
            clickAction: (i: number) => {
              this.sideNavButtons.forEach((button) => button.isSelected = false)
              this.sideNavButtons[i].isSelected = true
              this.sidenav.opened = false;
              this.router.navigate(['dashboard/ContentViewer/SubjectList']);
            },
            style: () => {
              if(window.location.pathname.includes('ContentViewer'))
                return this.selectedMenuClass
              else
                return this.notSelectedMenuClass
            },
            mobileStyle: () => {
              if(window.location.pathname.includes('ContentViewer'))
                return this.mobileSelectedMenuClass
              else
                return this.mobileNotSelectedClass
            },
            isSelected: window.location.pathname.includes('ContentViewer')
          })
        }
        if(user.result.some(el => el.ui === 'AgreementManage')) {
          this.sideNavButtons.splice(4, 0, {
            name: 'Agreements',
            icon: faFileContract,
            clickAction: (i: number) => {
              this.sideNavButtons.forEach((button) => button.isSelected = false )
              this.sideNavButtons[i].isSelected = true
              this.sidenav.opened = false;
              this.institutionClick()
            },
            style: () => {
              if(window.location.pathname.includes('AgreementManagement'))
                return this.selectedMenuClass
              else
                return this.notSelectedMenuClass
            },
            mobileStyle: () => {
              if(window.location.pathname.includes('AgreementManagement'))
                return this.mobileSelectedMenuClass
              else
                return this.mobileNotSelectedClass
            },
            isSelected: window.location.pathname.includes('AgreementManagement')
          })
        }
        // TODO one more for system manage thing
        if(user.result.some(el => el.ui === 'MessageManage') || user.result.some(el => el.ui === 'BrandingManage')) {
          this.sideNavButtons.splice(6, 0, {
            name: 'System',
            icon: faGear,
            clickAction: (i: number) => {
              this.sideNavButtons.forEach((button) => button.isSelected = false )
              this.sideNavButtons[i].isSelected = true
              this.sidenav.opened = false;
              this.systemClick()
            },
            style: () => {
              if(window.location.pathname.includes('SystemManagement'))
                return this.selectedMenuClass
              else
                return this.notSelectedMenuClass
            },
            mobileStyle: () => {
              if(window.location.pathname.includes('SystemManagement'))
                return this.mobileSelectedMenuClass
              else
                return this.mobileNotSelectedClass
            },
            isSelected: window.location.pathname.includes('SystemManagement')
          })
        }
        if(user.result.some(el => el.ui === 'ClassroomAdmin')) {
          this.sideNavButtons.splice(5, 0, {
            name: 'Subsections',
            icon: faGraduationCap,
            clickAction: (i: number) => {
              this.sideNavButtons.forEach((button) => button.isSelected = false )
              this.sideNavButtons[i].isSelected = true
              this.sidenav.opened = false;
              this.router.navigate(['dashboard/subsections/list']);
            },
            style: () => {
              if(window.location.pathname.includes('subsections'))
                return this.selectedMenuClass
              else
                return this.notSelectedMenuClass
            },
            mobileStyle: () => {
              if(window.location.pathname.includes('subsections'))
                return this.mobileSelectedMenuClass
              else
                return this.mobileNotSelectedClass
            },
            isSelected: window.location.pathname.includes('subsections')
          })
        }
        if(this.examAdminDashboard ? (this.examStudentDashboard || this.examStudentClassroomDashboard) : (this.examStudentDashboard && this.examStudentClassroomDashboard)) {

          if(this.examAdminDashboard) {
            this.dashboardSwitchMenuItems.push({
              title: 'Admin',
              action: () => {
                this.switchDashboards(Dashboard.admin)
              }
            })
          }

          if(this.examStudentDashboard) {
            this.dashboardSwitchMenuItems.push({
              title: 'Placement Student',
              action: () => {
                this.switchDashboards(Dashboard.placement_student)
              }
            })
          }

          if(this.examStudentClassroomDashboard) {
            this.dashboardSwitchMenuItems.push({
              title: 'Classroom Student',
              action: () => {
                this.switchDashboards(Dashboard.classroom_student)
              }
            })
          }

          this.showSwitchButton = true
          this.examStudentDashboard = false
          this.examStudentClassroomDashboard = false
          this.examAdminDashboard = true
        } else if(this.examStudentDashboard) {
          this.examStudentDashboard = true
          this.examAdminDashboard = false
        } else if(this.examAdminDashboard) {
          this.examStudentDashboard = false
          this.examStudentClassroomDashboard = false
        } else if(this.examStudentClassroomDashboard) {
          this.examStudentDashboard = false
          this.examAdminDashboard = false
        }
      }
      this.permissionLoadingValue = 100
      this.permissionIsLoading = false
    } else {
      this._snackBar.open(user.msg, 'Dismiss', {panelClass: ['error-snackbar']})
    }
  })

  ngOnInit() {
    // Extremely convoluted way to switch dashboards
    this.dashboardService.sharedData.subscribe(data=>{
      this.examStudentDashboard= data === Dashboard.placement_student
      this.examStudentClassroomDashboard= data === Dashboard.classroom_student

      if(this.examStudentClassroomDashboard) {
        this.sideNavButtons = this.classroomStudentSideNavButtons
      }
    })
  }

  ngOnDestroy(): void {
    this.userSub.unsubscribe();
    this.userPermissionSub.unsubscribe();
  }

  onToggleOpen() {
    if (screen.width > 1024) this.isOpened = !this.isOpened;
    else {
      this.isOpened = false;
      this.sidenav.toggle();
    }
  }

  logout() {
    this.authService.logout();
  }

  institutionClick() {
    this.sidenav.opened = false;
    this.router.navigate(['dashboard/AgreementManagement/list']);
  }

  systemClick() {
    this.sidenav.opened = false;
    this.router.navigate(['dashboard/SystemManagement']);
  }

  dashboardClick() {
    if(this.sidenav != null)
      this.sidenav.opened = false;
    this.router.navigate(['dashboard']);
  }

  profile() {
    this.router.navigate(['dashboard/profile'], {queryParams: {email: 'mine'}})
  }

  contentExplorer() {
    window.open('https://d3jv850pnkwotx.cloudfront.net/explorer', '_blank')?.focus();
  }

  userManagement() {
    this.router.navigate(['dashboard/UserManagement']);
  }

  examListAdminClick() {
    this.router.navigate(['dashboard/exam/list']);
  }

  switchDashboards(s:Dashboard) {
    //this.examStudentDashboard = s
    this.dashboardService.setParam(s)
    this.router.navigate([''])
  }

  // protected readonly external = external;
  protected readonly localStorage = localStorage;
  protected readonly faFileCircleQuestion = faFileCircleQuestion;
  protected readonly faChevronDown = faChevronDown;
  protected readonly document = document;
}
